import { HttpClient } from '../../httpClient';
import { throwIfNotAllowedContentType, validateHttpResponse } from '../../httpClient/utils.ts';
import { IAnswerForStats } from './interfaces.ts';

export interface IGetAnswersFilter {
  periodId?: string
  role?: string
  level?: string
  name?: string
  subName?: string
  responseType?: string
  assessmentTypeId?: string
}

export const getAnswers = async (client: HttpClient, filters: IGetAnswersFilter): Promise<IAnswerForStats[]> => {
  const response = await client.get<IAnswerForStats[]>(`/api/v2/answers`, {
    params: filters
  })

  await validateHttpResponse(response)
  throwIfNotAllowedContentType(response, ['application/json'])

  return response.data
}
